import { lazy } from 'react'

const AuthRoutes = [
  {
    path: '/login',
    component: lazy(() => import('../../views/login')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/forgot-password',
    component: lazy(() => import('../../views/forgot-password')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/reset-password/:token?',
    component: lazy(() => import('../../views/reset-password')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/register',
    component: lazy(() => import('../../views/register')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/thanks-for-registering',
    component: lazy(() => import('../../views/register/register-thanks')),
    layout: 'BlankLayout',
    meta: {
      authRoute: false
    }
  },
  {
    path: '/rules',
    component: lazy(() => import('../../views/home/rules')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/register-confirm/:token',
    component: lazy(() => import('../../views/register/register-confirm')),
    exact: true,
    meta: {
      authRoute: true
    }
  }
]

export default AuthRoutes
